import { useTranslations } from 'next-intl';
import { useEffect, useState } from 'react';
import { useDebouncedCallback } from 'use-debounce';

import { formattedPrice } from '@/fo/ui/kit/price/base';
import { UiKitSliderBase } from '@/fo/ui/kit/slider/base';

import { FilterOptionRange } from '../../../types';
import { FilterComponentProps } from '../types';

import { styles } from './RangeFilter.styles';

/** Компонент для отображения range фильтров */
export function RangeFilter({
  options,
  selected,
  onChange
}: FilterComponentProps) {
  const rangeOptions = options as FilterOptionRange;
  const slots = styles();
  const t = useTranslations();

  const [internalValue, setInternalValue] = useState<[number, number]>(
    Array.isArray(selected)
      ? (selected as [number, number])
      : [rangeOptions.from, rangeOptions.to]
  );

  useEffect(() => {
    setInternalValue((prev) => {
      const newValue = Array.isArray(selected)
        ? (selected as [number, number])
        : ([rangeOptions.from, rangeOptions.to] as [number, number]);

      if (prev[0] === newValue[0] && prev[1] === newValue[1]) {
        return prev;
      }

      return newValue;
    });
  }, [selected, rangeOptions.from, rangeOptions.to]);

  const debouncedOnChange = useDebouncedCallback((value: [number, number]) => {
    onChange(value);
  }, 300);

  const handleChange = (value: [number, number]) => {
    setInternalValue(value);
    debouncedOnChange(value);
  };

  return (
    <div className={slots.base()}>
      <UiKitSliderBase
        min={rangeOptions.from}
        max={rangeOptions.to}
        value={internalValue}
        onChange={handleChange}
        labelFrom={
          selected?.[0]
            ? `${t('from')} ${formattedPrice(+selected?.[0])}`
            : rangeOptions.fromLabel
        }
        labelTo={
          selected?.[1]
            ? `${t('up to')} ${formattedPrice(+selected?.[1])}`
            : rangeOptions.toLabel
        }
      />
    </div>
  );
}
